import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Cookies from 'js-cookie';
import { Typography } from '@mui/material';

const CRMLogin = () => {
  const [password, setPassword] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  const message = location.state?.message;

  const handlePasswordSubmit = async () => {
    console.log('setting password in cookies...')
    Cookies.set('authPassword', password, { expires: 1 }); // Set cookie for 1 day
    navigate('/customers'); // Redirect to the desired page
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '50px' }}>
      <h2>Enter Password</h2>
      <input
        type="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        placeholder="Enter password"
        style={{ marginBottom: '10px', padding: '8px', width: '200px' }}
      />
      <button onClick={handlePasswordSubmit} style={{ padding: '8px 16px' }}>
        Enter
      </button>
      {message && <Typography color={'secondary'}>{message}</Typography>}
    </div>
  );
};

export default CRMLogin;
